import { mutationOptions, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import type {
    ChangeEmailInput,
    ChangePasswordInput,
    ConfirmIdentityInput,
} from '../model/user.types';
import { userApi } from './user.api';
import { userQueryKeys } from './user.queries';

export function useSignOutOptions() {
    return mutationOptions({
        mutationFn: () => userApi.signOut(),
        onError: () => {
            toast.error('Failed to sign out');
        },
    });
}

// onSent belongs here rather than in a per-call mutate callback: those are dropped when the
// caller unmounts, and the whole route tree sits under a Suspense fallback that can swap it out.
export function resendEmailVerificationOptions(onSent?: () => void) {
    return mutationOptions({
        mutationFn: () => userApi.resendEmailVerification(),
        onSuccess: onSent,
        onError: () => {
            toast.error('Something went wrong sending the email. Please try again.');
        },
    });
}

export function useChangePasswordOptions() {
    const queryClient = useQueryClient();
    return mutationOptions({
        mutationFn: (input: ChangePasswordInput) => userApi.changePassword(input),
        onSuccess: () => {
            toast.success('Password updated!');
            queryClient.invalidateQueries({ queryKey: userQueryKeys.passwordStatus });
        },
    });
}

export function confirmIdentityOptions() {
    return mutationOptions({
        mutationFn: (input: ConfirmIdentityInput) => userApi.confirmIdentity(input),
    });
}

export function useChangeEmailOptions() {
    const queryClient = useQueryClient();
    return mutationOptions({
        mutationFn: (input: ChangeEmailInput) => userApi.changeEmail(input),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: userQueryKeys.emailVerificationStatus });
        },
    });
}
